import { put, takeEvery } from 'redux-saga/effects';
import * as commonTypes from '@store/common/types';
import * as metricsChartContainerTypes from '@store/metricsChartContainer/types';
import * as birdChartTypes from '@store/trends/birdChart/types';
import * as actions from './actions';

// reset the session table on some user actions
function* resetSessionTable(action) {
  if (!action.skipPersistence) {
    yield put(actions.restBucketTime());
    yield put(actions.resetLegends());
    yield put(actions.setHighlightBucket(''));
  }
}

function* watchSessionTableReset() {
  yield takeEvery([
    commonTypes.APPLY_FILTER, // filter
    metricsChartContainerTypes.SELECTED_METRIC_CHART, // selected metric
    birdChartTypes.SET_SLICE, // time slice selection
  ], resetSessionTable);
}

export default [
  watchSessionTableReset,
];
